import { combineEpics } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs';

import module from './index';

import products from 'domains/products';

import { notNull } from 'utils/type_guards';

import type { Epic } from 'redux-observable';
import type { Action } from '@reduxjs/toolkit';
import type { RootState } from 'store/wos_store';

const { actions } = module;

/**
 * If we change to a custom size product, we need to initialize the size and set rotation to 0
 */
const initializeCustomSizeEpic: Epic<Action, Action, RootState> = (action$, state$) =>
  action$.pipe(
    filter(actions.changeActiveCanvasConfig.product.match),
    withLatestFrom(state$),
    map(([action, state]) => {
      const product = products.selectors.selectById(state, action.payload);
      if (!product || !products.utils.isCustomSizeProduct(product)) return;

      return product;
    }),
    filter(notNull),
    map((p) =>
      actions.changeActiveCanvasConfig.size({
        height: parseFloat(p.print_size_y),
        width: parseFloat(p.print_size_x),
      })
    )
  );

/**
 * If the active product changes to a standard size, and we have custom size data, clear it
 */
const tearDownCustomSizeEpic: Epic<Action, Action, RootState> = (action$, state$) =>
  action$.pipe(
    filter(actions.changeActiveCanvasConfig.product.match),
    withLatestFrom(state$),
    map(([action, state]) => {
      const product = products.selectors.selectById(state, action.payload);
      if (!product || products.utils.isCustomSizeProduct(product)) return;

      return state;
    }),
    filter(notNull),
    map(() => {
      return {
        customPrice: undefined,
        customOptionPrices: undefined,
        height: undefined,
        width: undefined,
      };
    }),
    map(actions.updateCanvas)
  );

const combined = combineEpics(initializeCustomSizeEpic, tearDownCustomSizeEpic);
export default combined;
